import {useQuery} from '@tanstack/react-query';
import {toast} from 'sonner';
import {QUERY_CACHE_KEYS} from 'utils/constants';
import {useChekinSDK} from 'context/ChekinSDK';
import {FastAPIServiceError, Guidebook} from '@guestapp/sdk';

type Props = {
  groupId?: string;
};
function useFetchGuidebookGroups({groupId = ''}: Props) {
  const {getGuidebooksByGroup} = useChekinSDK();

  return useQuery<Guidebook[], FastAPIServiceError>(
    [QUERY_CACHE_KEYS.guidebookGroups, groupId],
    () => getGuidebooksByGroup(groupId),
    {
      enabled: Boolean(groupId),
      refetchOnWindowFocus: false,
      onError: error => {
        const errorMessage =
          error?.detail && Array.isArray(error.detail)
            ? error.detail[0].msg
            : error?.message || 'An unexpected error occurred';

        toast.error(errorMessage);
      },
    },
  );
}

export {useFetchGuidebookGroups};
